import React, { useLayoutEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FiPhoneCall } from "react-icons/fi";
import homeBanner from "../assets/images/banner.webp";
import logo from "../assets/images/logo.png";

const Header = ({ scrollToContact }) => {
  const [isSticky, setIsSticky] = useState(false);
  const bannerRef = useRef(null);
  const location = useLocation();

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (bannerRef.current) {
        setIsSticky(window.scrollY > 200);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const path = location.pathname;

  let bannerImage = homeBanner;
  let title = "Welcome to Our Sarvagys Institute";
  let subtitle = "Learn skills, grow your career, and explore our wide range of courses.";
  let showExploreBtn = true;
  let bannerHeight = "h-[80vh] sm:h-[95vh]";
  let showBanner = true;

  if (path === "/about") {
    bannerImage = null; 
    title = "About Us";
    subtitle = "Learn more about our journey, mission, and vision.";
    showExploreBtn = false;
    bannerHeight = "h-[500px]"; 
  } else if (path === "/courses") {
    bannerImage = null;
    title = "Our Courses";
    subtitle = "Explore our wide range of learning opportunities.";
    showExploreBtn = false;
    bannerHeight = "h-[500px]";
  } else if (path === "/contact-us") {
    bannerImage = null;
    title = "Contact Us";
    subtitle = "We’d love to hear from you — reach out for any questions or assistance..";
    showExploreBtn = false;
    bannerHeight = "h-[500px]";
  } else if (path.startsWith("/courses/")) {
    showBanner = false;
  }

  return (
    <div className="relative">
      <div
        className={`transition-all duration-300 ${
          isSticky
            ? "fixed top-0 left-0 right-0 bg-black bg-opacity-100 z-50 shadow-md"
            : "absolute top-0 left-0 right-0 bg-transparent z-20"
        }`}
      >
        <div className="flex items-center justify-between px-6 py-3 text-white">
          <Link to="/" className="flex items-center gap-2">
            <img src={logo} className="w-full h-24 object-contain inset-0" />
            {/* <span className="font-bold text-xl">Sarvagys Institute</span> */}
          </Link>

          <nav className="hidden md:flex gap-6 font-semibold text-lg">
            <Link to="/" className="hover:text-pink-400">Home</Link>
            <Link to="/about" className="hover:text-pink-400">About</Link>
            <Link to="/courses" className="hover:text-pink-400">Courses</Link>
            <Link to="/contact-us" className="hover:text-pink-400">
              Contact Us
            </Link>
          </nav>
          <div className="flex items-center gap-2">
            <FiPhoneCall className="text-pink-400 text-xl" />
            <span className="font-semibold">9755897963</span>
          </div>
        </div>
      </div>

      {/* Banner Section */}
      {showBanner && (
      <div
        ref={bannerRef}
        className={`relative ${bannerHeight} flex items-center justify-center text-center text-white`}
      >
        {bannerImage ? (
          <>
            <img src={bannerImage} alt="Header" className="w-full h-full object-cover absolute inset-0" />
            <div className="absolute inset-0 bg-black/40"></div>
          </>
        ) : (
          <div className="absolute inset-0 bg-gray-900"></div>
        )}

        {/* Text */}
        <div className="relative z-10 px-4">
          <h1 className="text-3xl md:text-5xl font-bold">{title}</h1>
          <p className="mt-4 text-lg md:text-xl max-w-2xl mx-auto">{subtitle}</p>

          {showExploreBtn && (
            <Link
              to="/courses"
              className="mt-6 inline-block bg-gradient-to-r from-pink-500 to-purple-600 text-white px-6 py-3 rounded-full font-semibold shadow-lg hover:from-pink-600 hover:to-purple-700"
            >
              Explore Courses →
            </Link>
          )}
        </div>
      </div>
      )}
    </div>
  );
};

export default Header;
